import { IField } from '@hooks/useField';
import { FormGroup, FormControlLabel, FormControlLabelProps, Switch } from '@material-ui/core';
import React from 'react';

export type SwitchFieldProps = Omit<FormControlLabelProps, "control"> & {
    field: IField
    updateFieldStateOnChange?: boolean
    onValueChanged?: (newValue: any) => void
    color?: 'primary' | 'secondary' | 'default'
}

export function SwitchField ({field, updateFieldStateOnChange, onValueChanged, color, ...props}: SwitchFieldProps) {
    const boolToString = React.useCallback((value: boolean) => {
        return value ? "1" : "0";
    }, []);

    const stringToBool = React.useCallback((value: any) => {
        return value === "1";
    }, []);

    const [_value, _setValue] = React.useState(stringToBool(field.value));

    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, checked: boolean) => {
        if (checked !== _value) {
            _setValue(checked);
        }
    }, [_value]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        const stringValue = boolToString(_value); 

        field.setInputValue(stringValue);

        if (onValueChanged !== undefined) {
            onValueChanged(stringValue);
        }

        if (updateFieldStateOnChange === true && field.value !== stringValue) {
            field.setValue(stringValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, boolToString, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        const stringValue = boolToString(_value);
        
        if (field.value !== stringValue) {
            _setValue(stringToBool(field.value));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value, boolToString]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(stringToBool(field.initialValueRef?.current));
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <FormGroup>
            <FormControlLabel
                {...props}
                control={<Switch 
                    checked={_value} 
                    onChange={handleChange} 
                    color={color || "primary"}
                />}
            />
        </FormGroup>
    )
}